var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.985 1.409.765 8.152 4.26-3.178-3.177 4.26 8.152.766-8.152.765 3.178 4.26-4.26-3.177-.766 8.152-.765-8.152-4.261 3.178 3.178-4.26-8.152-.766 8.152-.766-3.178-4.26 4.26 3.178z"
  })));
};
export default SvgStar;